import Application from "../../Application";
import DeleteDocumentTypeFromOrganisationInteractor from "../../documentTypes/interactors/DeleteDocumentTypeFromOrganisationInteractor";
import Constants from "../common/Constants";

export default class RemoveDocumentLegalViewTypeInteractor {
  private application: Application;
  private deleteDocumentTypeFromOrganisationInteractor: DeleteDocumentTypeFromOrganisationInteractor;

  constructor({ application, deleteDocumentTypeFromOrganisation }) {
    this.application = application;
    this.deleteDocumentTypeFromOrganisationInteractor =
      this.deleteDocumentTypeFromOrganisationInteractor =
        deleteDocumentTypeFromOrganisation;
  }

  execute(organisationId: number, legalViewTypeId: number) {
    return this.deleteDocumentTypeFromOrganisationInteractor.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.legalViewTypesPath}`,
      legalViewTypeId
    );
  }
}
